export { WidgetJsonConfiguration } from './widget-json-configuration'
